import React from 'react';
import { Link } from 'react-router-dom';
import LandingTemplate from '../LandingTemplate';

export default function ConfirmEmailFailure() {
  return <LandingTemplate>
    This link is expired. Please <Link to="/signup">Sign Up</Link> to start using our app.
  </LandingTemplate>
}